/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { SetStateAction, useAtom } from "jotai";
import React from "react";
import "react-phone-input-2/lib/bootstrap.css";
import { formListOptionsAtom, ItemType } from "../../pages/form-builder";
import StyledCheckBox from "../StyledCheckBox";
import { StyledRadio } from "../StyledRadio";
import { Empty } from "./FormBuilderEditor";

const Content = styled.div`
  padding: 10px;
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  width: fit-content;

  .form-list-item {
    display: flex;
    grid-gap: 5px;
    align-items: center;

    .form-item-empty {
      color: #70707090;
    }

    .styled-checkbox,
    .styled-radio {
      width: 1em;
      height: 1em;
      max-width: 1em;
      max-height: 1em;
    }
  }
`;

interface Props {
  item: ItemType;
  setItem: (update: SetStateAction<ItemType>) => void;
  isSelected?: boolean;
  isPreview?: boolean;
}

export default function FormBuilderList(props: Props): JSX.Element {
  const [listOptions, setListOptions] = useAtom(formListOptionsAtom);

  if (!props.item?.state?.options || props.item?.state?.options?.length === 0)
    return <Empty>Add list</Empty>;

  return (
    <div
      css={css`
        display: flex;
        pointer-events: ${props.isPreview ? "auto" : "none"};
        width: 100%;
        justify-content: ${props.item.state?.align || "center"};
      `}
    >
      <Content>
        {props.item.state?.options?.map((item) => {
          const isChecked = listOptions?.some(
            (option) => option.id === item.id
          );
          return (
            <div className="form-list-item">
              {props.item.state?.allowMultipleSelections ? (
                <StyledCheckBox
                  check={!!isChecked}
                  handleCheck={() => {
                    if (isChecked) {
                      setListOptions(
                        listOptions.filter((option) => option.id !== item.id)
                      );
                    } else {
                      setListOptions([...listOptions, item]);
                    }
                  }}
                />
              ) : (
                <StyledRadio
                  check={!!isChecked}
                  handleCheck={() => {
                    if (isChecked) {
                      setListOptions([]);
                    } else {
                      setListOptions([item]);
                    }
                  }}
                />
              )}{" "}
              {item.label || (
                <span className="form-item-empty">Option {item.index + 1}</span>
              )}
            </div>
          );
        })}
      </Content>
    </div>
  );
}
